import { render, staticRenderFns } from "./authSSO.vue?vue&type=template&id=3c51b02b&scoped=true"
import script from "./authSSO.vue?vue&type=script&lang=js"
export * from "./authSSO.vue?vue&type=script&lang=js"
import style0 from "./authSSO.vue?vue&type=style&index=0&id=3c51b02b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c51b02b",
  null
  
)

export default component.exports